// Firestore helpers for company ↔ client document sharing
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  where,
} from 'firebase/firestore';
import { firestore } from '../firebase';

export const shareDocId = (ownerUid, fileName) => `${ownerUid}__${fileName}`;

export const shareDocRef = (companyUid, ownerUid, fileName) =>
  doc(firestore, 'companyShares', companyUid, 'photos', shareDocId(ownerUid, fileName));

export async function markShared({
  companyUid,
  ownerUid,
  fileName,
  storagePath,
  title,
  takenByPseudo,
  timestamp,
  size,
  contentType,
}) {
  if (!companyUid || !ownerUid || !fileName) return;

  await setDoc(
    shareDocRef(companyUid, ownerUid, fileName),
    {
      ownerUid,
      fileName,
      companyUid,
      storagePath: storagePath || `${ownerUid}/photos/${fileName}`,
      sharedBy: ownerUid,
      sharedAt: serverTimestamp(),
      title: title || null,
      takenByPseudo: takenByPseudo || null,
      timestamp: timestamp || Date.now(),
      size: size ?? null,
      contentType: contentType || null,
      status: 'active',
    },
    { merge: true }
  );
}

export async function unshare({ companyUid, ownerUid, fileName }) {
  if (!companyUid || !ownerUid || !fileName) return;
  await deleteDoc(shareDocRef(companyUid, ownerUid, fileName));
}

export async function isShared({ companyUid, ownerUid, fileName }) {
  if (!companyUid || !ownerUid || !fileName) return false;
  const snap = await getDoc(shareDocRef(companyUid, ownerUid, fileName));
  return snap.exists();
}

export async function listSharedForUser(companyUid, ownerUid) {
  if (!companyUid || !ownerUid) return [];
  const q = query(
    collection(firestore, 'companyShares', companyUid, 'photos'),
    where('ownerUid', '==', ownerUid)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function listCompanyShares(companyUid) {
  if (!companyUid) return [];
  const col = collection(firestore, 'companyShares', companyUid, 'photos');
  const snap = await getDocs(col);
  return snap.docs.map((d) => {
    const data = d.data() || {};
    return {
      id: d.id,
      ...data,
      companyUid: data.companyUid || companyUid,
    };
  });
}

export async function listSharedForUserByCompany(companyUid, ownerUid) {
  if (!companyUid || !ownerUid) return [];
  const q = query(
    collection(firestore, 'companyShares', companyUid, 'photos'),
    where('ownerUid', '==', ownerUid)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data() || {};
    return { id: d.id, ...data, companyUid: data.companyUid || companyUid };
  });
}
